export default Object.freeze({
  aether: 'Aether',
  albedo: 'Albedo',
  aloy: 'Aloy',
  amber: 'Amber',
  aratakiitto: 'Arataki Itto',
  barbara: 'Barbara',
  baizhu: 'Baizhu',
  beidou: 'Beidou',
  bennett: 'Bennett',
  candace: 'Candace',
  chongyun: 'Chongyun',
  collei: 'Collei',
  cyno: 'Cyno',
  dainsleif: 'Dainsleif',
  diluc: 'Diluc',
  eula: 'Eula',
  fischl: 'Fischl',
  ganyu: 'Ganyu',
  gorou: 'Gorou',
  hutao: 'Hu-Tao',
  jean: 'Jean',
  kaedeharakazuha: 'Kaedehara Kazuha',
  kaeya: 'Kaeya',
  kamisatoayaka: 'Kamisato Ayaka',
  keqing: 'Keqing',
  kujousara: 'Kujou Sara',
  kukishinobu: 'Kuki Shinobu',
  layla: 'Layla',
  lisa: 'Lisa',
  lumine: 'Lumine',
  other: 'Other',
  mona: 'Mona',
  nilou: 'Nilou',
  ningguang: 'Ningguang',
  noelle: 'Noelle',
  raidenshogun: 'Raiden Shogun',
  razor: 'Razor',
  rosaria: 'Rosaria',
  sangonimiyakokomi: 'Sangonomiya Kokomi',
  scaramouche: 'Scaramouche',
  shenhe: 'Shenhe',
  shikanoinheizon: 'Shikanoin Heizou',
  signora: 'Signora',
  sucrose: 'Sucrose',
  tartaglia: 'Tartaglia',
  tighnari: 'Tighnari',
  thoma: 'Thoma',
  venti: 'Venti',
  xiangling: 'Xiangling',
  xiao: 'Xiao',
  xingqiu: 'Xingqiu',
  xinyan: 'Xinyan',
  yaemiko: 'Yae Miko',
  yanfei: 'Yanfei',
  yelan: 'Yelan',
  yoimiya: 'Yoimiya',
  yunjin: 'Yun Jin',
  zhongli: 'Zhongli'
})